import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import type from './type';

const URL_ACTIONS = `${BASE_API}/actions/establishment/user`;

const URL_USER_DONE_ACTION = `${BASE_API}/actions/user-done`;

export const getActionsByEstablishmentId = (id) => {
  return (dispatch) => {
    dispatch([
      {
        type: type.ACTIONS_USER_LOAD,
        payload: true,
      },
    ]);

    axios
      .get(`${URL_ACTIONS}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: type.ACTIONS_USER_FETCHED,
            payload: response.data,
          },
        ]);
      });
  };
};

export const finishActionShare = () => {
  return (dispatch) => {
    axios
      .post(URL_USER_DONE_ACTION, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {});
  };
};
